import { render, staticRenderFns } from "./PowerModeTextarea.vue?vue&type=template&id=50bbd621&scoped=true"
import script from "./PowerModeTextarea.vue?vue&type=script&lang=js"
export * from "./PowerModeTextarea.vue?vue&type=script&lang=js"
import style0 from "./PowerModeTextarea.vue?vue&type=style&index=0&id=50bbd621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bbd621",
  null
  
)

export default component.exports